import Default from '../component/general/dashboard/default';
import AddSession from '../component/sessions/addsession';
import SessionList from '../component/sessions/sessionlist';
import SessionManage from "../component/common/session/manage/SessionManage";
import SessionView from "../component/common/session/view/SessionView";
import Utenti from '../component/crud/utenti/utenti';
import Gruppi from '../component/crud/gruppi/gruppi';
import Relatori from '../component/crud/relatori/relatori';
import GruppiRelatori from '../component/crud/gruppirelatori/gruppirelatori';
import Profilo from '../component/general/profilo/profilo';

export const routes = [
    { path: "/dashboard/default", Component: Default },
    { path:"/sessions/add", Component: AddSession },
    { path:"/sessions", Component: SessionList },
    { path:"/sessions/view", Component: SessionView },
    { path:"/sessions/manage", Component: SessionManage },
    { path:"/users", Component: Utenti },
    { path:"/speakers", Component: Relatori },
    { path:"/speakers_groups", Component: GruppiRelatori },
    { path:"/groups", Component: Gruppi },
    { path:"/profilo", Component: Profilo },
]

